export default {
  copy(idPlant) {
    const paramStr = '?anleggsid=';
    var urlStr;
    if (window.location.href.includes(paramStr)) {
      let index = window.location.href.indexOf('=');
      urlStr = window.location.href.slice(0, index + 1) + idPlant;
    } else {
      urlStr = window.location.href + paramStr + idPlant;
    }

    var textArea = document.createElement('textarea');
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = 0;
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = urlStr;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Copying text command was ' + msg);
    } catch (err) {
      console.log('Oops, unable to copy');
    }

    document.body.removeChild(textArea);
  }
};



/** WEBPACK FOOTER **
 ** app/components/common/clipboard.js
 **/